import PropTypes from "prop-types";
import GivEnergyLogo from "./givenergy-logo";
import LoginHero from "assets/login-hero.webp";

export function MainWrapper({title, description, children}) {
  return (
    <div className="min-h-full flex flex-col justify-center h-full w-full overflow-x-hidden">
      <div
        className="bg-white dark:bg-green-500 md:shadow-md shadow-none w-full flex h-full grow">
        <div className="lg:basis-2/3 basis-1/3 md:block hidden">
          <img src={LoginHero} className="object-cover h-full"/>
        </div>
        <div
          className="lg:basis-1/3 md:basis-2/3 grow flex flex-col gap-8 items-center justify-center p-8 pb-0 px-12 overflow-x-hidden">
          <div className="flex flex-col gap-6 justify-center w-full grow">
            <GivEnergyLogo className="mx-auto w-[200px] h-auto"/>

            <div>
              {title && (
                <h1 className="dark:text-white text-green-500 text-md text-center font-semibold">
                  {title}
                </h1>
              )}

              {description && (
                <p className="text-center dark:text-zinc-300 text-zinc-500">
                  {description}
                </p>
              )}
            </div>

            <div className="w-full">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

MainWrapper.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
};
